export default __webpack_public_path__ + "static/Montserrat-Regular-ac98a5f5ca71180fe293683b5ea727a8.ttf";